<template>
  <i :class="iconClass"/>
</template>

<script>

import {
  DEFAULT_ICON,
  getRouteIcon,
  ROUTE_ADMIN_CHAT,
  ROUTE_AGGR_CONFIGS,
  ROUTE_AGGREGATOR,
  ROUTE_CONFIGS,
  ROUTE_FILES,
  ROUTE_CURRENCIES,
  ROUTE_CURRENCY_CONFIGS,
  ROUTE_DEALERS,
  ROUTE_ENGINE_OPERATORS,
  ROUTE_GAME_TYPES,
  ROUTE_LIMITS,
  ROUTE_LOCALIZATION,
  ROUTE_MANAGEMENT,
  ROUTE_OPERATORS,
  ROUTE_PARTNERS,
  ROUTE_PROXY,
  ROUTE_SOURCES,
  ROUTE_TABLE_LIMITS,
  ROUTE_TABLES,
  ROUTE_USERS,
  ROUTE_WAZDAN_FREESPINS
} from "../utils/routerIcons";

export default {
  props: {
    management: {
      type: Boolean,
      default: false,
    },
    users: {
      type: Boolean,
      default: false,
    },
    partners: {
      type: Boolean,
      default: false,
    },
    operators: {
      type: Boolean,
      default: false,
    },
    tables: {
      type: Boolean,
      default: false,
    },
    sources: {
      type: Boolean,
      default: false,
    },
    proxy: {
      type: Boolean,
      default: false,
    },
    currencies: {
      type: Boolean,
      default: false,
    },
    currencyConfigs: {
      type: Boolean,
      default: false,
    },
    configs: {
      type: Boolean,
      default: false,
    },
    files: {
      type: Boolean,
      default: false,
    },
    gameTypes: {
      type: Boolean,
      default: false,
    },
    aggrConfigs: {
      type: Boolean,
      default: false,
    },
    engineOperators: {
      type: Boolean,
      default: false,
    },
    aggregator: {
      type: Boolean,
      default: false,
    },
    limits: {
      type: Boolean,
      default: false,
    },
    dealers: {
      type: Boolean,
      default: false,
    },
    localization: {
      type: Boolean,
      default: false,
    },
    tableLimits: {
      type: Boolean,
      default: false,
    },
    wazdanFreespins: {
      type: Boolean,
      default: false,
    },
    adminChat: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    iconClass() {
      if (this.adminChat) {
        return getRouteIcon(ROUTE_ADMIN_CHAT);
      }
      if (this.aggrConfigs) {
        return getRouteIcon(ROUTE_AGGR_CONFIGS);
      }
      if (this.aggregator) {
        return getRouteIcon(ROUTE_AGGREGATOR);
      }
      if (this.configs) {
        return getRouteIcon(ROUTE_CONFIGS);
      }
      if (this.files) {
        return getRouteIcon(ROUTE_FILES);
      }
      if (this.currencies) {
        return getRouteIcon(ROUTE_CURRENCIES);
      }
      if (this.currencyConfigs) {
        return getRouteIcon(ROUTE_CURRENCY_CONFIGS);
      }
      if (this.dealers) {
        return getRouteIcon(ROUTE_DEALERS);
      }
      if (this.engineOperators) {
        return getRouteIcon(ROUTE_ENGINE_OPERATORS);
      }
      if (this.gameTypes) {
        return getRouteIcon(ROUTE_GAME_TYPES);
      }
      if (this.limits) {
        return getRouteIcon(ROUTE_LIMITS);
      }
      if (this.localization) {
        return getRouteIcon(ROUTE_LOCALIZATION);
      }
      if (this.management) {
        return getRouteIcon(ROUTE_MANAGEMENT);
      }
      if (this.operators) {
        return getRouteIcon(ROUTE_OPERATORS);
      }
      if (this.partners) {
        return getRouteIcon(ROUTE_PARTNERS);
      }
      if (this.proxy) {
        return getRouteIcon(ROUTE_PROXY);
      }
      if (this.sources) {
        return getRouteIcon(ROUTE_SOURCES);
      }
      if (this.tableLimits) {
        return getRouteIcon(ROUTE_TABLE_LIMITS);
      }
      if (this.tables) {
        return getRouteIcon(ROUTE_TABLES);
      }
      if (this.users) {
        return getRouteIcon(ROUTE_USERS);
      }
      if (this.wazdanFreespins) {
        return getRouteIcon(ROUTE_WAZDAN_FREESPINS);
      }

      return DEFAULT_ICON;
    },
  },
}
</script>
